import _ from 'lodash';
import { useMemo } from 'react';

import { IndexFredCode } from 'generated/graphql';

import {
  FullWidthSummaryCardLayout,
  StandardSourceMetricCard
} from 'modules';



export type LaborMarketSummaryCardProps<T extends (StandardSourceMetricCard.StandardSourceMetricCardProps)[]> = {
  data: T;
  fredCodes: IndexFredCode[];
};



export const FC = <T extends (StandardSourceMetricCard.StandardSourceMetricCardProps)[]> (props: LaborMarketSummaryCardProps<T>) => {
  const data = useMemo(() => {
    return _.compact(props.fredCodes.map((metric) => props.data.find((node) => node.fredCode === metric)));
  }, [
    props.data,
    props.fredCodes
  ]);



  return (
    <FullWidthSummaryCardLayout.FC
      dataLink=''
      dataSource='Labor Market'
    >
      <>
        {
          data.map((metric, i) => {
            return (
              <StandardSourceMetricCard.FC
                key={`${metric.fredCode}-${i}`}
                color='PRIMARY'
                {...metric}
              />
            );
          })
        }
      </>
    </FullWidthSummaryCardLayout.FC>
  );
};
